import script from "./ComunidadCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ComunidadCard.vue?vue&type=script&setup=true&lang=js"

import "./ComunidadCard.vue?vue&type=style&index=0&id=f34effb8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f34effb8"]])

export default __exports__